<!-- TODO: Component relies heavily on Angular Material v16 which has been deprecated.
 Consider migrating to v21 or reducing dependency on Angular Material -->

<section
    id="service-insights-table"
    class="flex flex-col p-6 gap-6 border-solid border-1 border-sky-blue rounded-lg"
  >
    <div
      id="service-insights-table-title"
      class="text-2xl pb-6 text-neptune-color-primary neptune-border-b-1 border-sky-blue"
    >
      Service Insights
    </div>
    <div class="flex flex-col">
      <section
        id="service-insights-tab-container"
        class="flex w-full bg-neptune-muted"
        *ngIf="!tabsAreLoading; else serviceInsightsTableTabsSkeleton"
      >
        <div
          id="service-insights-table-overall-tab"
          class="px-4 py-3 flex items-center w-1/3 cursor-pointer justify-center font-medium"
          [attr.aria-selected]="tabSelected === 'overall'"
          [ngClass]="
            tabSelected == 'overall'
              ? 'neptune-border-b-2 border-blue'
              : 'neptune-border-b-1 border-neptune-border-subtle'
          "
          (click)="changeTab('overall')"
        >
          Overall
        </div>
        <div
          id="service-insights-table-issues-tab"
          class="px-4 py-3 flex items-center w-1/3 cursor-pointer justify-center font-medium"
          [attr.aria-selected]="tabSelected === 'issues'"
          [ngClass]="
            tabSelected == 'issues'
              ? 'neptune-border-b-2 border-blue'
              : 'neptune-border-b-1 border-neptune-border-subtle'
          "
          (click)="changeTab('issues')"
        >
          Issues
        </div>
        <div
          id="service-insights-table-recurring-issues-tab"
          class="px-4 py-3 flex items-center w-1/3 cursor-pointer justify-center font-medium"
          [attr.aria-selected]="tabSelected === 'recurring'"
          [ngClass]="
            tabSelected == 'recurring'
              ? 'neptune-border-b-2 border-blue'
              : 'neptune-border-b-1 border-neptune-border-subtle'
          "
          (click)="changeTab('recurring')"
        >
          Recurring Issues
        </div>
      </section>

      <section
        id="service-insights-table-body"
        class="flex flex-col w-full p-6 gap-6 box-border bg-neptune-color-primary-50"
      >
        <ng-container
          *ngIf="!tabDataIsLoading; else serviceInsightsTableSkeleton"
        >
          <section
            id="observations-kpi-container"
            class="flex flex-col md:flex-row gap-4"
          >
            <observations-kpi-card
              class="flex-1"
              *ngFor="let item of observationsData; let i = index"
              [id]="'c' + (i + 1)"
              [observationsData]="observationsData[i]"
              [totalItems]="observationsData.length"
            ></observations-kpi-card>
          </section>

          <!-- Table displaying Overall/Issues/Recurring issues data.-->
          <section
            id="service-insights-issues-table"
            class="w-full overflow-x-auto"
          >
            <table
              class="table-fixed box-border min-w-[720px] border-collapse w-full"
              *ngIf="dataSource.data.length; else noData"
            >
              <thead id="service-insights-issues-table-header">
                <tr
                  class="neptune-border-b-1 border-neptune-border-subtle bg-neptune-muted"
                >
                  <th>
                    <div class="flex px-4 py-3 items-center">Locations</div>
                  </th>
                  <th>
                    <div class="flex px-4 py-3 items-center">Finding</div>
                  </th>
                  <th>
                    <div class="flex px-4 py-3 items-center">Implications</div>
                  </th>
                  <th>
                    <div class="flex px-4 py-3 items-center">Next Steps</div>
                  </th>
                  <th>
                    <div class="flex px-4 py-3 items-center">
                      <label class="flex items-center gap-2">
                        <input
                          type="checkbox"
                          class="w-4 h-4 accent-blue"
                          #addAllBox
                          [checked]="addAll"
                          (click)="_addAll(addAllBox.checked)"
                        />&nbsp;Add All
                      </label>
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody id="service-insights-issues-table-body" class="text-base">
                <tr
                  *ngFor="let element of dataSource.data; let i = index"
                  class="odd:bg-white even:bg-neptune-muted"
                >
                  <!-- Locations -->
                  <td [id]="'location-' + (i + 1)">
                    <div class="flex flex-col px-4 py-2 gap-2">
                      <div>
                        <div
                          class="text-blue cursor-pointer hover:underline"
                          (click)="
                            onUnitsClick(
                              element.totalLocations,
                              element.addresses
                            )
                          "
                        >
                          <span class="total-locations">{{
                            element.totalLocations
                          }}</span>
                          Units with
                        </div>

                        <div class="text-xs">
                          <span class="observation-count">{{
                            element.observationCount
                          }}</span>
                          instances
                        </div>
                      </div>
                    </div>
                  </td>

                  <!-- Finding -->
                  <td
                    [id]="'finding-' + (i + 1)"
                    class="max-w-0 overflow-hidden"
                  >
                    <div
                      class="flex flex-col px-4 py-2 gap-2 text-sm min-w-0"
                      [title]="element.observationName"
                    >
                      <span class="block truncate">
                        {{ element.observationName }}
                      </span>
                    </div>
                  </td>

                  <!-- Implications -->
                  <td [id]="'implications-' + (i + 1)">
                    <div
                      *ngIf="element.implications.length === 0"
                      class="add-implications-button flex gap-2 cursor-pointer text-sm items-center"
                      (click)="onClick(element, false)"
                    >
                      <img
                        alt="plus-icon"
                        src="../assets/shared-icons/neptune-icon-blue-plus-sign.svg"
                      />&nbsp; Add Implications
                    </div>

                    <div
                      *ngIf="element.implications.length > 0"
                      class="flex px-4 py-2"
                    >
                      <div
                        class="flex w-full justify-between p-2 gap-2 bg-neptune-subtle"
                      >
                        <ul
                          class="implications-list max-w-[calc(100%-24px)] min-w-0 list-disc pl-4 m-0"
                        >
                          <li
                            *ngFor="let item of element.implications"
                            [title]="item"
                          >
                            <span class="truncate block text-xs">
                              {{ item }}
                            </span>
                          </li>
                        </ul>

                        <img
                          alt="pencil-icon"
                          src="../assets/shared-icons/neptune-icon-blue-pencil.svg"
                          class="implications-edit w-6 h-6 shrink-0 cursor-pointer"
                          (click)="onEditImplications(element)"
                        />
                      </div>
                    </div>
                  </td>

                  <!-- Next Steps -->
                  <td [id]="'next-steps-' + (i + 1)">
                    <div
                      *ngIf="element.nextSteps.length === 0"
                      class="add-next-steps-button flex gap-2 cursor-pointer text-sm items-center"
                      (click)="onClick(element, true)"
                    >
                      <img
                        alt="plus-icon"
                        src="../assets/shared-icons/neptune-icon-blue-plus-sign.svg"
                      />&nbsp; Add Next Steps
                    </div>

                    <div
                      *ngIf="element.nextSteps.length > 0"
                      class="flex px-4 py-2"
                    >
                      <div
                        class="flex w-full justify-between p-2 gap-2 bg-neptune-subtle"
                      >
                        <ul
                          class="next-steps-list max-w-[calc(100%-24px)] min-w-0 list-disc pl-4 m-0"
                        >
                          <li
                            *ngFor="let item of element.nextSteps"
                            [title]="item"
                          >
                            <span class="truncate block text-xs">
                              {{ item }}
                            </span>
                          </li>
                        </ul>

                        <img
                          alt="pencil-icon"
                          src="../assets/shared-icons/neptune-icon-blue-pencil.svg"
                          class="next-steps-edit w-6 h-6 shrink-0 cursor-pointer"
                          (click)="onEditNextSteps(element)"
                        />
                      </div>
                    </div>
                  </td>

                  <!-- Add -->
                  <td [id]="'add-' + (i + 1)">
                    <div class="flex flex-col px-4 py-2 gap-2 text-sm">
                      <label class="flex items-center gap-2">
                        <input
                          type="checkbox"
                          class="w-4 h-4 accent-blue"
                          #addOne
                          [checked]="element.checked"
                          (change)="_addOne(element, addOne.checked)"
                        />&nbsp;Add
                      </label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
        </ng-container>
      </section>
    </div>
  </section>

<ng-template #noData>
  <div
    id="service-insights-no-data"
    class="flex flex-col items-center justify-center gap-4 py-12 w-full h-full"
  >
    <span class="text-lg text-neptune-text-subtle font-bold">
      No data available for the selected tab. Updating your filters may help you
      find relevant results.
    </span>
  </div>
</ng-template>

<ng-template #serviceInsightsTableSkeleton>
  <section
    id="serviceInsightsTableSkeleton"
    class="flex flex-col gap-6 animate-pulse"
  >
    <!-- observations-kpi-card-skeleton.component.html -->
    <section class="flex flex-col md:flex-row gap-4">
      <div
        *ngFor="let item of [1, 2, 3]"
        class="flex-1 p-4 border rounded-lg bg-white w-full h-full"
      >
        <div class="flex flex-col justify-between items-start gap-2">
          <div class="h-10 w-16 bg-neptune-subtle rounded"></div>
          <div class="h-5 w-3/4 bg-neptune-subtle rounded"></div>
        </div>
      </div>
    </section>

    <!-- Table -->
    <section class="overflow-x-auto">
      <table class="w-full bg-white">
        <thead>
          <tr class="bg-gray-100">
            <th><div class="h-5 w-24 rounded m-3"></div></th>
            <th><div class="h-5 w-20 rounded m-3"></div></th>
            <th><div class="h-5 w-24 rounded m-3"></div></th>
            <th><div class="h-5 w-24 rounded m-3"></div></th>
            <th><div class="h-5 w-16 rounded m-3"></div></th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let row of [1, 2, 3]" class="border-b border-gray-100">
            <td class="p-4">
              <div class="h-4 w-20"></div>
              <div class="h-3 w-12"></div>
            </td>

            <td class="p-4">
              <div class="h-4 w-full"></div>
            </td>

            <td class="p-4">
              <div class="h-10 w-full"></div>
            </td>

            <td class="p-4">
              <div class="h-10 w-full"></div>
            </td>

            <td class="p-4">
              <div class="h-4 w-12"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </section>
</ng-template>

<ng-template #serviceInsightsTableTabsSkeleton>
  <section
    id="service-insights-tab-container"
    class="flex w-full bg-neptune-muted"
  >
    <div
      class="px-4 py-3 flex items-center w-1/3 cursor-pointer justify-center font-medium"
    >
      <span class="bg-neptune-muted w-5 rounded h-4"></span>
    </div>
    <div
      class="px-4 py-3 flex items-center w-1/3 cursor-pointer justify-center font-medium"
    >
      <span class="bg-neptune-muted w-5 rounded h-4"></span>
    </div>
    <div
      class="px-4 py-3 flex items-center w-1/3 cursor-pointer justify-center font-medium"
    >
      <span class="bg-neptune-muted w-5 rounded h-4"></span>
    </div>
  </section>
</ng-template>
